<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 29.0283C22.6758 29.0283 29.0332 22.6709 29.0332 14.9951C29.0332 7.31934 22.6611 0.961914 14.9854 0.961914C7.30957 0.961914 0.966797 7.31934 0.966797 14.9951C0.966797 22.6709 7.32422 29.0283 15 29.0283ZM15 26.9043C8.4082 26.9043 3.12012 21.6016 3.12012 14.9951C3.12012 8.40332 8.39355 3.10059 14.9854 3.10059C21.5918 3.10059 26.8945 8.40332 26.9092 14.9951C26.9092 21.6016 21.6064 26.9043 15 26.9043ZM13.4912 21.5723C13.9014 21.5723 14.2529 21.3672 14.502 20.9863L20.9912 10.8057C21.1377 10.5713 21.2842 10.2783 21.2842 10.0146C21.2842 9.45801 20.7861 9.07715 20.2588 9.07715C19.9365 9.07715 19.6143 9.28223 19.3945 9.64844L13.4326 19.1406L10.5176 15.4492C10.2246 15.0537 9.94629 14.9365 9.59473 14.9365C9.05273 14.9365 8.61328 15.376 8.61328 15.9473C8.61328 16.2109 8.73047 16.4893 8.90625 16.7236L12.4219 20.9863C12.7441 21.3965 13.0664 21.5723 13.4912 21.5723Z" fill="#009621"/>
  </svg>
</template>
<script>
export default {
  name: 'CheckIcon',
  props: {
    color: {
      type: String,
      default: '#fc2504'
    }
  }
};
</script>
